import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnSA: CultureInfo = {
  name: 'en-SA',
  displayName: 'English (Saudi Arabia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-SA',
  parent: CultureInfoEn
};
